// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IsLoggedInInERP_vpnTxt__e0gwl {
  position: sticky;
  z-index: 9999999999999999999999999999999999999999999999;
  display: flex;
  justify-content: center;
  color: red;
  font-size: 24px;
  font-weight: 500;
  padding-top: 20px;
  font-family: Estedad !important;
}
`, "",{"version":3,"sources":["webpack://./src/RoutesControllers/IsLoggedInInERP.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uDAAuD;EACvD,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC","sourcesContent":[".vpnTxt {\r\n  position: sticky;\r\n  z-index: 9999999999999999999999999999999999999999999999;\r\n  display: flex;\r\n  justify-content: center;\r\n  color: red;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  padding-top: 20px;\r\n  font-family: Estedad !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vpnTxt": `IsLoggedInInERP_vpnTxt__e0gwl`
};
export default ___CSS_LOADER_EXPORT___;
